import { render, staticRenderFns } from "./milestone-form.vue?vue&type=template&id=5f1d2c50&scoped=true&"
import script from "./milestone-form.vue?vue&type=script&lang=ts&"
export * from "./milestone-form.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-form.vue?vue&type=style&index=0&id=5f1d2c50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1d2c50",
  null
  
)

export default component.exports